import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import ProductService from 'src/services/product.service'

export const useProductOverrideUrl = (lngCode: string, productId?: string) => {
  return useQuery(
    [QUERY_KEYS.PRODUCT_URL, productId, lngCode],
    () => (productId ? ProductService.getOverrideUrl(productId, lngCode) : null),
    { refetchOnWindowFocus: false },
  )
}
